<template>
  <header class="bg-dark">
    <b-navbar class="py-xl-3" id="nav" toggleable="xl" type="dark" variant="dark">
      <b-navbar-brand :href="tasracingWebsite">
        <img alt class="img-fluid ml-4 mr-4" id="navbar-brand" src="/img/logo.svg"/>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <div id="nav_menu">
          <div id="nav__menu__inner">
            <ul class="navbar-nav mr-auto text-uppercase fz13">
              <li class="nav-item mx-1 px-2">
                <a :href="tasracingWebsite+'/form'" class="nav-link nav__menu__item fw9">
                  FORM
                  GUIDES
                </a>
              </li>
              <li class="nav-item mx-1 px-2">
                <a :href="tasracingWebsite+'/news'" class="nav-link nav__menu__item fw9">NEWS</a>
              </li>
              <li class="nav-item mx-1 px-2">
                <a
                        :href="tasracingWebsite + '/replays/'"
                        class="nav-link nav__menu__item fw9"
                >REPLAYS</a>
              </li>
              <li class="nav-item mx-1 pl-2">
                <a :href="tasracingWebsite+'/ondemand'" class="nav-link nav__menu__item fw9">
                  ON
                  DEMAND
                </a>
              </li>
              <li class="nav-item dropdown ml-0 ml-xl-2 mb-1 mb-xl-0 mt1px">
                <a
                        class="nav-link dropdown-toggle br20 pl-3 nav-pad align-middle mt-1 nav__menu__item prominent fw9"
                        href="https://tasracingcorporate.com.au/"
                        target="_blank"
                >
                  <i class="fas fa-chevron-right icons-ext"></i>INDUSTRY
                </a>
              </li>
              <li class="nav-item dropdown ml-0 mb-1 mb-xl-0 mt1px">
                <a
                        class="nav-link dropdown-toggle nav-pad pl-3 br20 align-middle mt-1 nav__menu__item prominent fw9"
                        href="https://goracingtasmania.com.au/"
                        target="_blank"
                >
                  <i class="fas fa-chevron-right icons-ext"></i>GO RACING TASMANIA
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- Right aligned nav items -->
        <ul class="list-inline m-0 list-unstyled py-3 py-lg-0 ml-auto navbar-nav px-2" v-if="userInfo.data && userInfo.data.username">
          <li class="list-inline-item">
            <router-link :to="{name: 'account'}" class="color-menu nav-link fw6">
              <u>HI {{userInfo.data.firstName.toUpperCase()}}</u>, YOU ARE SIGNED IN
            </router-link>
          </li>
          <li class="list-inline-item" v-if="displaySignout">
            <span @click.prevent="logout"
                    class="nav-link cursor-pointer txt-sans text-uppercase fz14 signout">Sign out</span>
          </li>
        </ul>
        <ul class="list-inline m-0 list-unstyled py-3 py-lg-0 ml-auto navbar-nav px-2" v-else>
          <li class="list-inline-item btn-login mb-2 mb-xl-0">
            <router-link :to="{name: 'signin'}" class="nav-link">
              Login
            </router-link>
          </li>
          <li class="list-inline-item btn-signup mb-2 mb-xl-0">
            <router-link :to="{name: 'signup'}" class="nav-link">
              Join
            </router-link>
          </li>
        </ul>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
  import {Auth} from "aws-amplify";
  import {clearTwitterToken} from "@/commons";
  import {signout} from "../../commons";
  import config from "../../config";

  export default {
    name: "NavigationBar",
    methods: {
      async logout() {
        await Auth.signOut();
        clearTwitterToken();
        await signout();
        this.$store.dispatch("clearStoreForNewUser");
        this.$router.replace("/signin");
      }
    },
    computed: {
      displaySignout() {
        return this.userInfo && this.userInfo.data && this.userInfo.data.username;
      },
      userInfo() {
        return this.$store.state.user;
      },
      tasracingWebsite() {
        return config.tasracingWebsite;
      }
    }
  };
</script>

<style scoped lang="scss">

  .btn-login {
    font-size: 11px;
    font-weight: 600;
    padding: 0.05rem 1rem;
    border-radius: 20px;
    color: #CADAE3 !important;
    transition: all 0.5s ease;
    border: 1px solid white;
    text-transform: uppercase;
  &:hover{
     background-color: #32454f;
     color: #99CC33 !important;
   }

  }
  .btn-signup {
    font-size: 11px;
    font-weight: 600;
    padding: 0.05rem 1rem;
    border-radius: 20px;
    color: black !important;
    transition: all 0.5s ease;
    border: 1px solid white;
    text-transform: uppercase;
    background-color: #ffffff;
    a {
      color:black !important;
    }
    &:hover{
      background-color: #32454f;
      a {
        color: #99CC33 !important;
      }

    }
  }
  .mt1px {
    margin-top: 1px;
  }

  .icons-ext {
    margin-right: 6px;
    margin-left: 2px;
  }

  .txt-sans {
    font-family: "Open Sans", sans-serif;
  }

  .nav-link {
    transition: color 0.5s ease;
  }

  .acc-link {
    font-size: 1.35rem;
    line-height: 24px;
  }

  .signout{
    color: #64696F !important;
    font-weight: 600;
    font-family: 'Open Sans', sans-serif;
  }
</style>
